import { render, staticRenderFns } from "./rg05.vue?vue&type=template&id=9c356170&scoped=true"
import script from "./rg05.vue?vue&type=script&lang=js"
export * from "./rg05.vue?vue&type=script&lang=js"
import style0 from "./rg05.vue?vue&type=style&index=0&id=9c356170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c356170",
  null
  
)

export default component.exports